export interface MeetingSummaryStates {
  content: string;
}

export const getMeetingSummaryInitState = (): MeetingSummaryStates => {
  return {
    content: "",
  };
};
